module.exports = __webpack_public_path__ + "media/images/allcare-card-cbe6b46cd27a771c9e6b0ce743210617.png";